// This file contains utility functions for converting an ArrayBuffer to a string,
// which is often used in cryptographic operations like generating code challenges for OAuth flows.
export function convertBufferToString(hash: ArrayBuffer) {
  const uintArray = new Uint8Array(hash);
  const numberArray = Array.from(uintArray);
  return String.fromCharCode(...numberArray);
}
